import React from "react";
import { AddDistributionsContainer } from "../../../containers";

const AddDistributions = (props) => {
  return <AddDistributionsContainer {...props} />;
};

export default AddDistributions;
